import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'

const WordlistTab = ({
  children,
  active = false,
  className,
  ...forwardedProps
}) => {
  if (active) {
    return (
      <div className="border-b py-1 mb-2 text-sm">
        <span
          className={classNames([
            'rounded-t px-2 py-1 mr-2 border-t border-r border-l bg-white',
            'text-pv-green-dark',
            className,
          ])}
          style={{
            borderBottom: '1px solid transparent',
            marginBottom: '-1px',
            paddingBottom: '5px',
          }}
          {...forwardedProps}
        >
          {children}
        </span>
      </div>
    )
  }
  return (
    <div className="border-b py-1 mb-2 text-sm">
      <a
        className={classNames([
          'rounded-t px-2 py-1 mr-2 border-t border-r border-l bg-white',
          className,
        ])}
        style={{
          borderBottom: '1px solid transparent',
          marginBottom: '-1px',
        }}
        {...forwardedProps}
      >
        {children}
      </a>
    </div>
  )
}

WordlistTab.propTypes = {
  children: PropTypes.node,
  active: PropTypes.bool,
  className: PropTypes.any,
}

export default WordlistTab
